export default 'https://support.blockchain.com/hc'
